import { render, staticRenderFns } from "./TableV2.vue?vue&type=template&id=57542b60"
import script from "./TableV2.vue?vue&type=script&lang=js"
export * from "./TableV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports